import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from '@/store/store';
import Vuetify from 'vuetify';
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'

import '@/components';
import '@/components/answers';
import '@/components/questions';
import '@/components/intros';
import '@/components/officemanagement';
import '@/components/admin';
import '@/components/navigation';
import { SURVEY_MODEL_DATA } from '@/common/surveyData';
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vuetify/dist/vuetify.min.css';
import TextareaAutosize from 'vue-textarea-autosize';
import VueScrollactive from 'vue-scrollactive';
import ConstPlugin from '@/plugins/ConstPlugin.js'
import Loader from "@/components/Loader.vue";

// -------------------------------------------------------------
// 🔧 GLOBAL ERROR SUPPRESSION (DISABLE POPUP OVERLAY)
// -------------------------------------------------------------
Vue.config.errorHandler = function (err, vm, info) {
  console.error('[Vue error suppressed]:', err);
};

Vue.config.warnHandler = function (msg, vm, trace) {
  console.warn('[Vue warning suppressed]:', msg);
};

// Optional: silence Vue warnings entirely
Vue.config.silent = true;

// -------------------------------------------------------------
// 🔧 SUPPRESS NavigationDuplicated / Redirected ERRORS
// -------------------------------------------------------------
const originalPush = router.push;
router.push = function push (location) {
  return originalPush.call(this, location).catch(err => err);
};

const originalReplace = router.replace;
router.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err);
};

// -------------------------------------------------------------
// 🔧 VUE APP SETUP
// -------------------------------------------------------------
Vue.config.productionTip = false;

Vue.component("loader", Loader);
Vue.use(Vuetify);
Vue.use(BootstrapVue);
Vue.use(TextareaAutosize);
Vue.use(VueScrollactive);
Vue.use(ConstPlugin);
Vue.use(Chartkick.use(Chart));

SURVEY_MODEL_DATA.surveyStore = store;

// -------------------------------------------------------------
// 🔧 CREATE APP
// -------------------------------------------------------------
new Vue({
  icons: {
    iconfont: 'mdi'
  },
  router,
  store,
  vuetify: new Vuetify(),
  render: h => h(App)
}).$mount('#app');
